import { motion } from "framer-motion";
import { Tractor, Truck, Building2, Package, Ship, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "engins",
    icon: Tractor,
    title: "Location d'Engins de Chantier",
    subtitle: "Pelle mécanique, Bulldozer, Niveleuse, Compacteur",
    description: "Matériel lourd haute performance adapté aux contraintes des terrains équatoriaux et chantiers isolés de Guyane.",
    badge: "Chantier & Terrassement",
    span: "lg:col-span-7",
    featured: true,
  },
  {
    id: "vehicules",
    icon: Truck,
    title: "Location de Véhicules",
    subtitle: "Pick-up 4x4, Camions benne, Utilitaires",
    description: "Flotte tout-terrain révisée pour franchir les pistes latéritiques de Maripasoula et l'arrière-pays.",
    badge: "Mobilité Tout-Terrain",
    span: "lg:col-span-5",
  },
  {
    id: "appartements",
    icon: Building2,
    title: "Location d'Appartements",
    subtitle: "Meublés, séjour professionnel & courte durée",
    description: "Hébergements climatisés et sécurisés au cœur de Maripasoula pour cadres, techniciens et visiteurs.",
    badge: "Séjour & Confort",
    span: "lg:col-span-4",
  },
  {
    id: "materiaux",
    icon: Package,
    title: "Vente de Matériaux BTP",
    subtitle: "Granulats, ciment, sable, grave, bois",
    description: "Approvisionnement garanti en matériaux de qualité pour tous vos travaux de construction.",
    badge: "Fourniture BTP",
    span: "lg:col-span-4",
  },
  {
    id: "transport",
    icon: Ship,
    title: "Transport Matériel & Matériaux",
    subtitle: "Fret terrestre & logistique fluviale Maroni",
    description: "Acheminement sécurisé de charges lourdes, conteneurs et engins à travers le réseau routier et fluvial guyanais.",
    badge: "Logistique Amazonienne",
    span: "lg:col-span-4",
  },
];

export const ServicePillars = ({ onQuote }) => (
  <section id="services" data-testid="service-pillars" className="relative py-24 sm:py-32 blueprint-grid">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <p className="font-mono text-xs tracking-[0.35em] uppercase text-[#E5A93C] mb-4">Nos 5 pôles</p>
        <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#F0F6FC] max-w-2xl leading-tight">
          Une seule équipe pour tous vos chantiers
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.id}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
            data-testid={`service-card-${s.id}`}
            className={`${s.span} group relative bg-[#161B22] border border-[#21262D] rounded-2xl p-7 sm:p-9 flex flex-col justify-between min-h-[240px] overflow-hidden transition-colors duration-300 hover:border-[#F2541B]/60`}
          >
            <div className="absolute -right-8 -top-8 text-[#21262D] group-hover:text-[#F2541B]/10 transition-colors duration-500">
              <s.icon size={s.featured ? 180 : 130} strokeWidth={1} />
            </div>

            <div className="relative">
              <span className="inline-block font-mono text-[10px] uppercase tracking-[0.25em] text-[#E5A93C] border border-[#E5A93C]/25 rounded-full px-3 py-1 mb-5">
                {s.badge}
              </span>
              <h3 className="font-display font-bold uppercase tracking-tight text-xl sm:text-2xl text-[#F0F6FC]">
                {s.title}
              </h3>
              <p className="font-mono text-xs text-[#8B949E] mt-2 tracking-wide">{s.subtitle}</p>
              <p className="text-sm text-[#8B949E] leading-relaxed mt-4 max-w-md">{s.description}</p>
            </div>

            <button
              onClick={() => onQuote(s.id)}
              data-testid={`service-devis-${s.id}`}
              className="relative mt-8 self-start flex items-center gap-2 font-display font-bold uppercase text-sm tracking-wide text-[#F2541B] hover:text-[#F0F6FC] transition-colors duration-300"
            >
              Demander un devis
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
